import { FormQuestions } from 'types/FormsTypes';
export const StudentFeedbackQuestions: FormQuestions = [
  { id: 0, title: 'Jak bardzo podobały Ci się zajęcia?', value: 5 },
  { id: 1, title: 'Czy zagadnienia na lekcji były zrozumiałe?', value: 5 },
  { id: 2, title: 'Czy atmosfera na zajęciach sprzyja nauce?', value: 5 },
];
